module.exports = __webpack_public_path__ + "img/vote-loader-dark.3fa2a7ad.svg";